import { createFileRoute } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { Shop } from "@/features/site/modules/shop/shop";
import type { TrainerLoaderData } from "@/features/site/utils/trainer-head";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/$trainerSlug/shop/")({
  component: ShopPage,
  // The shelf is read before the page draws, so the products are in the server's HTML.
  loader: async ({ parentMatchPromise }) => {
    // Named by hand: with its `head` reading the loader's data too, the router infers the layout's as `never`.
    const loaded = (await parentMatchPromise).loaderData as TrainerLoaderData | undefined;
    const organizationId = loaded?.page.organizationId;
    const { data } = organizationId
      ? await sdk.publicShop.$get.setQueryParams({ organizationId }).send()
      : { data: null };
    return { crumb: m.shop_title(), products: data ?? undefined };
  },
});

function ShopPage() {
  const { products } = Route.useLoaderData();
  return <Shop initial={products} />;
}
